"use strict";

import angular from "angular";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";

import { AccountingPlanEntity } from "../../entity/AccountingPlanEntity";
import { nucontersUsers } from "../../utils/users-roles/users-roles";
import { PlanMockNew } from "../../shared/constants/plans.constants";
angular.module("nucont.adminUsers").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.admin-users", {
        url: "usuarios-administrativos",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return Promise.all([
                import(
                    /* webpackChunkName: "feature-admin-users" */ "./admin-users.component"
                ),
                import(
                    /* webpackChunkName: "feature-admin-users" */ "./dialogs/update-user-password/update-user-password.controller"
                )
            ]).then(() => $ocLazyLoad.inject("nucont.adminUsers"));
        },
        views: {
            "main@": {
                component: "adminLayoutComponent"
            },
            "admin@nucont.admin-users": {
                component: "adminUsersComponent"
            }
        },
        data: {
            rolesGuard: [...nucontersUsers],
            layoutConfig: {
                model: "LayoutConfigModel3",
                setAttrs: [
                    {
                        object: "headerConfig",
                        path: "moduleTitle.text",
                        value: "Gestão de Usuários"
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.description",
                        value: "Gerencie usuários, permissões e níveis de acesso da plataforma."
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.enabled",
                        value: true
                    }
                ]
            }
        },
        resolve: {
            jwtVerified: [
                "JWTService",
                (JWTService) => JWTService.verifyTokenOnce()
            ],
            validationsContract: [
                "NavigationService",
                (NavigationService) => {
                    const accountingPlanEntity = new AccountingPlanEntity(
                        PlanMockNew
                    );

                    NavigationService.setValidationsContract(
                        accountingPlanEntity
                    );
                }
            ],
            user: [
                () => {
                    let count = 0;
                    return new Promise((resolve, reject) => {
                        const checkUser = () => {
                            if (count > 3) return resolve(true);
                            if (new UserDataAdapter().user()?.role) {
                                return resolve(true);
                            } else {
                                setTimeout(() => {
                                    count++;
                                    checkUser();
                                }, 500);
                            }
                        };
                        checkUser();
                    });
                }
            ]
        },
        bodyClass: "admin-users-module"
    });
}
